module.exports = __webpack_public_path__ + "img/guy-with-shopping-cart.fb868ce5.gif";